import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import Hero from '../components/Hero';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import TermsImg from '../assets/images/hero-terms.jpg';

export default function Terms() {
  const m = meta.terms;
  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero title="Terms of Service" subtitle="Website and service use terms." bgImage={TermsImg} />
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography paragraph>
          Use of this website constitutes acceptance of these terms. Quotes are estimates until confirmed onsite.
          All services are performed to applicable codes and standards. Warranty terms are provided with each job.
        </Typography>
      </Container>
    </Box>
  );
}
